<vwui-modal-header>
    <h2>{{ 'SUBMIT_PROJECT_INTAKE.modal.title' | translate }}</h2>
</vwui-modal-header>
<vwui-modal-body>
    {{ 'SUBMIT_PROJECT_INTAKE.modal.question' | translate : { projectName } }}
</vwui-modal-body>
<vwui-modal-footer>
    <vwui-button class="is-light" (click)="modalRef.close(false)">
        {{ 'BUTTON.cancel' | translate }}
    </vwui-button>
    <vwui-button class="is-primary" (click)="modalRef.close(true)">
        {{ 'PAGE_QUICKSCAN_RESULT.button.save' | translate }}
    </vwui-button>
</vwui-modal-footer>
